import { InternalAxiosRequestConfig } from 'axios'
import { bs } from '../../state/bound.store'
import { getBaseUrl } from '../axios'
export const baseUrlWPRequestInterceptor = (
    request: InternalAxiosRequestConfig
) => {
    const controller = new AbortController()

    request.baseURL = getBaseUrl(request.ORG_OVERRIDE)

    if (!bs().selectedOrg?.name) {
        controller.abort()
    }

    return {
        ...request,
        signal: controller.signal,
    }
}
